import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import style from './trend.css';
import { formatSumData } from '../../utils/utils';

/* 单个图表的渲染 */
const Charts = function Charts(props) {
    const { xAxisData = [], seriesData = [] } = props;
    const mapRootRef = useRef(null); // echarts div
    const echartsRef = useRef(null); // echarts

    // 渲染图表
    const echartsRender = function echartsRender() {
        const options = {
            tooltip: {
                trigger: 'axis',
                showDelay: 0,
                enterable: true,
                transitionDuration: 0.2,
                padding: 8,
                borderWidth: 1,
                extraCssText: 'background: rgba(0, 0, 0, .6); box-shadow: 0 0 4 0 rgba(219, 219, 219, .5);',
                textStyle: {
                    color: '#ffffff',
                    fontSize: 12,
                    padding: 5,
                },
                formatter(params) {
                    const { name, value } = params[0];
                    const { unit, num } = formatSumData(value);

                    return `<div style="font-size: 12px; color: #fff;">
    <div style="margin-bottom: 8px;">${name}</div>
    <div>
        <span style="display: inline-block; width: 5px; height: 5px; vertical-align: 3px; border-radius: 5px; background-color: #4785f4"></span>
        <span class="margin-left: 4px;">中国：${num}${unit}剂</span>
    </div>
</div>`;
                },
                axisPointer: {
                    type: 'none',
                },
            },
            grid: {
                left: '3%',
                right: '3%',
                bottom: '3%',
                top: '3%',
                containLabel: true,
            },
            xAxis: {
                type: 'category',
                data: xAxisData,
            },
            yAxis: {
                type: 'value',
                min: 0,
                axisLabel: {
                    formatter(value) {
                        const { unit, num } = formatSumData(value);

                        return `${num}${unit}`;
                    },
                },
            },
            series: [
                {
                    type: 'line',
                    data: seriesData,
                    itemStyle: {
                        normal: {
                            color: '#4785f4',
                        },
                    },
                    showAllSymbol: false,
                },
            ],
        };

        echartsRef.current.setOption(options);
    };

    // 初始化图表
    const echartsInit = async function echartsInit() {
        const echarts = await import('echarts/lib/echarts');

        await Promise.all([
            import('echarts/lib/component/tooltip'), // 引入提示框和标题组件
            import('echarts/lib/chart/line'), // 引入提示框和标题组件
        ]);

        echartsRef.current = echarts.init(mapRootRef.current);
        echartsRender();
    };

    useEffect(() => {
        echartsInit();
    }, []);

    return <div ref={mapRootRef} className={style.chartRoot} />;
};

Charts.propTypes = {
    xAxisData: PropTypes.array,
    seriesData: PropTypes.array,
};

export default Charts;
